import { render } from "./VerticalNavMenu.vue?vue&type=template&id=725a8ccc"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"

import "./VerticalNavMenu.vue?vue&type=style&index=0&id=725a8ccc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__